import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=2f17b0fc&scoped=true"
import script from "./advantage.vue?vue&type=script&lang=js"
export * from "./advantage.vue?vue&type=script&lang=js"
import style0 from "./advantage.vue?vue&type=style&index=0&id=2f17b0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f17b0fc",
  null
  
)

export default component.exports